/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Import_LabelInputs */

const en_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const fr_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer`)
};

const de_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const it_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importare`)
};

const ru_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт`)
};

const es_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

const zh_cn2_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进口`)
};

const ja_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入`)
};

const hi_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात`)
};

const pt_pt2_shortcut_keys_import_label = /** @type {(inputs: Shortcut_Keys_Import_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

/**
* | output |
* | --- |
* | "Import" |
*
* @param {Shortcut_Keys_Import_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_import_label = /** @type {((inputs?: Shortcut_Keys_Import_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Import_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_import_label(inputs)
	if (locale === "de") return de_shortcut_keys_import_label(inputs)
	if (locale === "it") return it_shortcut_keys_import_label(inputs)
	if (locale === "ru") return ru_shortcut_keys_import_label(inputs)
	if (locale === "es") return es_shortcut_keys_import_label(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_import_label(inputs)
	if (locale === "ja") return ja_shortcut_keys_import_label(inputs)
	if (locale === "hi") return hi_shortcut_keys_import_label(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_import_label(inputs)
	return en_shortcut_keys_import_label(inputs)
});